module.exports = __webpack_public_path__ + "img/today.b6c17e54.png";